import './products.css';

import { Breadcrumb } from 'antd';
import { Image } from 'antd';
import { Storage } from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import BlockUi from 'react-block-ui';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';

import { Product, SubCategory } from '../../API';
import { FileUpload } from '../../components/fileUpload/FileUpload';
import ProductField from '../../components/Products/ProductField';
import { updateProduct } from '../../graphql/mutations';
import { fetchCategories } from '../../redux/actions/categoryActions';
import { fetchManufacturers } from '../../redux/actions/manufacturersActions';
import { AppState } from '../../redux/reducers';
import { unitTypes } from './AddProduct';
import { useProducts } from './useProducts';

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 200,
    height: 200,
    padding: 4,
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%',
};

const EditProduct: React.FC<AppState> = ({ manufacturers, categories }) => {
    const [files, setFiles] = useState<File[]>([]);
    const [oldImages, setOldImages] = useState<(string | null)[] | undefined | null>(null);
    const [productDetails, setProductDetails] = useState<Product | null>(null);
    const [subCategories, setSubCategories] = useState<any[]>([]);
    const [currentProductSubCategory, setCurrectProductSubCategory] = useState<SubCategory | null | undefined>(null);
    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState('');
    const [unitType, setUnitType] = useState('');
    const [unit, setUnit] = useState(0);
    const { params } = useRouteMatch();
    const { id } = params as any;

    const subCategoryRef = useRef<HTMLSelectElement | null>(null);
    const [state, setState] = useState<any>({});

    const { getProductDetails } = useProducts();

    const dispatch = useDispatch();

    const getProductInfo = async () => {
        const productResults = await getProductDetails(id);
        setUnit(Number(productResults?.product?.unit?.replace(/[^0-9]/g, '')) || 0);
        setUnitType(productResults?.product?.unit?.replace(/[^A-Za-z]/g, '').toLowerCase() || 'kg');
        setProductDetails(productResults.product as Product);
        const subCategories = categories?.categories.find((p) => p.name === productDetails?.type)?.subCategory;
        setSubCategories(subCategories as SubCategory[]);
        const getCurrentSubCategory = subCategories?.find((p) => p?.subCategoryId === productDetails?.subCategoryId);
        setCurrectProductSubCategory(getCurrentSubCategory);
        setState(productDetails);
        setOldImages(productDetails?.image as string[]);
        setLoading(false);
    };

    useEffect(() => {
        getProductInfo();
    }, [categories.categories]);

    useEffect(() => {
        dispatch(fetchManufacturers());
        dispatch(fetchCategories());
    }, []);

    const handleCategoryChange = (e: React.ChangeEvent<any>) => {
        setCategory(e.target.value);
        const getCategoryName = categories?.categories.find((p) => p.categoryId === e.target.value)?.name;
        setState({ ...state, type: getCategoryName });
        const subCategories = categories.categories.find((p) => p.categoryId === e.target.value)?.subCategory;
        setSubCategories(subCategories as SubCategory[]);
        setCurrectProductSubCategory(null);
    };

    const getPublicStorageUrl = (key: string) => {
        return `https://${process.env.REACT_APP_PRODUCT_IMAGE_STORAGE}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/public/${key}`;
    };

    const updateEditedProduct = async () => {
        try {
            if (!state.description || !state.name || !state.price || !state.quantity || !state.unit) {
                return toast.error('Kindly fill all fields to add a product');
            }
            setLoading(true);
            let uploads: (string | Object)[] = [];
            if (files.length > 0) {
                uploads = await uploadImage(files);
            }
            delete state.creationDate;
            delete state.productId;
            delete state.modificationDate;
            delete state.subCategoryName;
            state.unit = `${unit} ${unitType}`;
            const query = graphqlOperation(updateProduct, {
                productId: id,
                produces: {
                    ...state,
                    image: oldImages?.concat(uploads as string[]),
                    subCategoryId: subCategoryRef.current?.value,
                },
            });
            await API.graphql(query);
            setLoading(false);
            history.push(`/products/${id}`);
            return;
        } catch (e: any) {
            console.log(e);
            return toast.error(e);
        }
    };

    const uploadImage = useCallback(async (files: File[]) => {
        try {
            const fileKeys = files.map((file) => `products/${file.name}`);
            await Promise.all(
                files.map((file) => {
                    return Storage.put(`products/${file.name}`, file, {
                        contentType: 'image/*',
                        // authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    });
                }),
            );

            const images: Array<Object | string> = [];

            for (let i = 0; i < fileKeys.length; i++) {
                const url = getPublicStorageUrl(fileKeys[i]);
                console.log(url);
                images.push(url);
            }
            return images;
        } catch (e: any) {
            console.log({ e });
            throw e;
        }
    }, []);
    const history = useHistory();

    const cancelAddProduct = () => {
        history.push('/products');
    };

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const name = e.target.name;
        const value = e.target.value;

        setState({ ...state, [name]: value });
    };

    useEffect(
        () => () => {
            // Make sure to revoke the data uris to avoid memory leaks
            files.forEach((file) => URL.revokeObjectURL(URL.createObjectURL(file)));
        },
        [files],
    );

    const removeImage = async (file: string) => {
        return Swal.fire({
            title: 'Delete Product Image',
            text: 'Are you sure you want to remove this product image?',
            confirmButtonColor: '#f01d1d',
            icon: 'error',
            showCancelButton: true,
        }).then(async (results: any) => {
            if (results.value) {
                const productImages = productDetails?.image?.filter((p) => p !== file);
                setOldImages(productImages);
            }
        });
    };

    const getUploadedFiles = oldImages?.map((imageFile: any) => (
        <>
            <div style={thumb} key={imageFile}>
                <div style={thumbInner}>
                    <img src={imageFile} style={img} />
                </div>
                <div
                    style={{ color: 'red', cursor: 'pointer', position: 'absolute' }}
                    onClick={() => removeImage(imageFile)}
                >
                    Delete
                </div>
            </div>
        </>
    ));

    const handleManufacturerChange = (e: React.ChangeEvent<any>) => {
        setState({ ...state, manufacturerUserId: e.target.value });
    };

    const thumbs = files.map((file) => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img src={URL.createObjectURL(file)} style={img} />
            </div>
        </div>
    ));

    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <BlockUi blocking={loading}>
                            <ToastContainer />
                            <div>
                                <Breadcrumb separator=">">
                                    <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
                                    <Breadcrumb.Item>Products</Breadcrumb.Item>
                                    <Breadcrumb.Item href="">Edit Product</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>

                            <div>
                                <h6 className="products-heading">Edit Product sheet</h6>
                                <Card className="products-cardbody">
                                    <Card.Body>
                                        <Form className="p-3">
                                            <ToastContainer />
                                            <Row className="d-flex ">
                                                <Col md={6} className="">
                                                    <Form.Label className="new-product-form-label">
                                                        Manufacturer Name
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="manufacturerUserId"
                                                        onChange={handleManufacturerChange}
                                                    >
                                                        {manufacturers?.manufacturers?.map((manufacturer, k) => {
                                                            if (
                                                                manufacturer.username ===
                                                                productDetails?.manufacturerUserId
                                                            ) {
                                                                return (
                                                                    <option
                                                                        key={k}
                                                                        value={manufacturer.username}
                                                                        selected
                                                                    >
                                                                        {manufacturer.name}
                                                                    </option>
                                                                );
                                                            } else {
                                                                return (
                                                                    <option key={k} value={manufacturer.username}>
                                                                        {manufacturer.name}
                                                                    </option>
                                                                );
                                                            }
                                                        })}
                                                    </Form.Control>
                                                </Col>
                                                <Col md={6} className="">
                                                    <ProductField
                                                        label="QUANTITY"
                                                        value={state?.quantity || ''}
                                                        required
                                                        name="quantity"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="d-flex">
                                                <Col md={6} className="">
                                                    <ProductField
                                                        label="INPUT/PRODUCT NAME"
                                                        value={state?.name || ''}
                                                        placeholder="Enter Input name"
                                                        required
                                                        name="name"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                                <Col md={6} className="">
                                                    <Form.Label className="new-product-form-label">
                                                        Input Type
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        value={category}
                                                        onChange={handleCategoryChange}
                                                    >
                                                        {categories.categories.length > 0 ? (
                                                            <option
                                                                value={productDetails?.type as string}
                                                                key={productDetails?.type}
                                                            >
                                                                {productDetails?.type}
                                                            </option>
                                                        ) : (
                                                            <></>
                                                        )}
                                                        );
                                                        {categories?.categories?.map((category, k) => {
                                                            return (
                                                                <option value={category.categoryId} key={k}>
                                                                    {category.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Control>
                                                </Col>
                                            </Row>
                                            <Row className="d-flex">
                                                <Col md={6} className="">
                                                    <Form.Label className="new-product-form-label">
                                                        Sub Category
                                                    </Form.Label>
                                                    <Form.Control as="select" ref={subCategoryRef}>
                                                        );
                                                        {subCategories?.map((subcategory: SubCategory, k: any) => {
                                                            if (
                                                                subcategory.subCategoryId ===
                                                                currentProductSubCategory?.subCategoryId
                                                            ) {
                                                                return (
                                                                    <option
                                                                        selected
                                                                        value={subcategory.subCategoryId}
                                                                        key={k}
                                                                    >
                                                                        {subcategory.name}
                                                                    </option>
                                                                );
                                                            }
                                                            return (
                                                                <option value={subcategory.subCategoryId} key={k}>
                                                                    {subcategory.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Control>
                                                </Col>
                                                <Col md={4} className="">
                                                    <ProductField
                                                        name="unit"
                                                        label="QUANTITY TYPE"
                                                        type="number"
                                                        value={unit}
                                                        placeholder="Enter Quantity type"
                                                        onChange={(e) => setUnit(Number(e.target.value))}
                                                    />
                                                </Col>
                                                <Col md={2} className="">
                                                    <Form.Label className="new-product-form-label">Unit</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        value={unitType}
                                                        onChange={(e) => setUnitType(e.target.value)}
                                                    >
                                                        <option value="" key={99}>
                                                            Select Unit Type
                                                        </option>
                                                        {unitTypes.map(
                                                            (unit: { name: string; value: string }, k: any) => {
                                                                return (
                                                                    <option value={unit?.value} key={k}>
                                                                        {unit?.name}
                                                                    </option>
                                                                );
                                                            },
                                                        )}
                                                    </Form.Control>
                                                </Col>
                                            </Row>
                                            <Row className="d-flex">
                                                <Col md={6} className="">
                                                    <ProductField
                                                        label="DMA PRICE"
                                                        value={state?.dmaPrice || ''}
                                                        placeholder="Enter DMA price (KSH)"
                                                        required
                                                        name="dmaPrice"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                                <Col md={6} className="">
                                                    <ProductField
                                                        label="REBATES"
                                                        placeholder="Enter rebates (KSH)"
                                                        value={state?.rebates || ''}
                                                        required
                                                        name="rebates"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="d-flex">
                                                <Col md={6} className="">
                                                    <ProductField
                                                        name="price"
                                                        required
                                                        value={state?.price || ''}
                                                        placeholder="Enter unit price (KSH)"
                                                        label="UNIT PRICE"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="d-flex">
                                                <Col md={12}>
                                                    <ProductField
                                                        name="description"
                                                        required
                                                        value={state?.description || ''}
                                                        label="INPUT DESCRIPTION"
                                                        placeholder="Enter input description"
                                                        type="textarea"
                                                        onChange={handleOnChange}
                                                    />
                                                </Col>
                                            </Row>

                                            <Form.Group className="new-product-form-group" controlId="formBasicInputs">
                                                <Row>
                                                    <Col sm={6}>
                                                        <aside>
                                                            {getUploadedFiles}
                                                            {files.length > 0 ? (
                                                                thumbs
                                                            ) : (
                                                                <Col
                                                                    as={Image}
                                                                    height={'100%'}
                                                                    className="product-image"
                                                                    src="data:image/png;base64,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"
                                                                />
                                                            )}
                                                        </aside>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Label className="new-product-form-label">
                                                            Upload Images
                                                        </Form.Label>
                                                        <FileUpload files={files} setFiles={setFiles} />
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                            <Col className="mt-5 d-flex flex-row-reverse">
                                                <Button
                                                    onClick={updateEditedProduct}
                                                    className="primary-bg-color n-btn-style  white-color fw-500 m-3 px-5 btn-width"
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Loading...' : 'Update'}
                                                </Button>
                                                <Button
                                                    onClick={cancelAddProduct}
                                                    className="cancel-btn fw-500 m-3 btn-width muted-bg-color white-color px-5"
                                                >
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </div>
                        </BlockUi>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ manufacturers, categories }: AppState) => ({
    manufacturers,
    categories,
});

export default connect(mapStateToProps)(EditProduct);
